import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { KnBrConsentManagementPopupComponent } from './kn-br-consent-management-popup/kn-br-consent-management-popup.component';
import { ReactiveFormsModule } from '@angular/forms';
import { PageSlotModule } from '@spartacus/storefront';
import { I18nModule } from '@spartacus/core';

@NgModule({
  declarations: [KnBrConsentManagementPopupComponent],
  imports: [
    CommonModule,
    NgbModule,
    PageSlotModule,
    I18nModule,
    ReactiveFormsModule
  ],
  exports: [KnBrConsentManagementPopupComponent]
})
export class KnBrConsentManagementModule {}